/**
 * 商城mobx
 */
import { autorun } from 'mobx'
import restaurantCenter, { RESTAURANT_EVENT, Console } from './restaurantCenter'
import productMobx from './product.mobx'
import feeMobx from './fee.mobx'
import doProductMobx from './doProduct.mobx'
import cartMobx from './cart.mobx'
import mallMobx from './mall.mobx'
import discountMobx from './discount.mobx'
import storeMobx from './store.mobx'
import favoMobx from './favorite.mobx'
import shopcartMobx from './shopcart.mobx'
import { payPlanMobx, tipMobx, bankCardMobx } from './payment'
import * as shopcartCache from './shopcart.cache'
import appMobx from 'mobx/app/app.mobx'
import { memberMobx, multiPersonMobx } from '@mobxStore'
import { mpc } from '@dt/mmg-sdk'
import FeeClient from 'sdk/fee'
import mallPayChannelMobx from './payment/payChannel.mobx'

const restaurantConfig = restaurantCenter.config

export const Restaurant = {
  cartMobx,
  discountMobx,
  mallMobx,
  feeMobx,
  doProductMobx,
  productMobx,
  favoMobx,
  restaurantCenter,
  restaurantConfig,
  storeMobx,
  shopcartCache,
  shopcartMobx
}
export default Restaurant

/** 初始化营销sdk */
const initMpc = () => {
  mpc.init({
    brandId: restaurantConfig.brandId, // 品牌ID
    storeId: 0, // 门店ID
    domain: ENV.SERVERDOMAIN, // 域名
    eatType: 'mall' as any, // 吃的类型0
    appType: 'Mobile', // app类型
    channel: Config.buyTogetherId ? 'buyTogether' : 'mobile', // 渠道类型
    token: '',
    bo,
    canUseMmg: true,
    ...window.grayMaker()
  }).then(() => {
    // console.log('mmg mpc init success')
  })
  // mkt 获取用户信息
  if (Config.token) memberMobx.initMpc()
}

/** 初始化商城 */
export function mallInit (data?: any) {
  const { BRANDID } = Config
  restaurantCenter.setConfig({
    brandId: BRANDID,
    storeId: 0,
    lbs: {
      lat: Config.LBS.latitude,
      lng: Config.LBS.longitude
    },
    app: 'mobile',
    displayMode: 'waterfall',
    mpc,
    bo,
    deviceId: appMobx.deviceId,
    promotionId: Config.promotionId
  })
  if (bo !== 'cn') {
    feeMobx.init().then((feeConfig: any) => {
      // feeConfig.tax = null
      FeeClient.init(feeConfig)
      restaurantCenter.setConfig({
        fee: FeeClient
      })
    }, (err: any) => {
      console.error('🍄init fee error', err)
    })
  }
  initMpc()
  autorun(async () => {
    if (memberMobx.isLogin) {
      // console.log('🍙 营销会员信息置入 mpc')
      restaurantCenter.setConfig({
        member: {
          type: memberMobx.memberInfo.type,
          id: String(memberMobx.memberInfo.memberId),
          mobile: memberMobx.memberInfo.mobile,
          email: memberMobx.memberInfo.email,
          key: bo === 'cn' ? (String(memberMobx.memberInfo.memberId) || memberMobx.memberInfo.visitorId) : (memberMobx.memberInfo.visitorId || String(memberMobx.memberInfo.memberId)),
          nickName: memberMobx.memberInfo.nickName,
          avatar: memberMobx.memberInfo.avatarUrl,
          openId: memberMobx.memberInfo.openId
        }
      })
      // restaurantCenter.setConfig('person', memberMobx.memberInfo.memberId.toString())
    } else {
      restaurantCenter.setConfig({
        member: {
          type: multiPersonMobx.currentPersonInfo?.personType as any,
          key: multiPersonMobx.currentPersonInfo?.personId,
          nickName: multiPersonMobx.currentPersonInfo?.nickName
        }
      })
    }
    mallPayChannelMobx.init()
  })
  storeMobx.initList(data)
}

(window as any).MallRestaurantMobx = Restaurant as any

export {
  restaurantCenter,
  restaurantCenter as mallCenter,
  restaurantConfig,
  restaurantConfig as mallConfig,
  RESTAURANT_EVENT,
  mallMobx,
  productMobx,
  productMobx as mallProductMobx,
  favoMobx,
  cartMobx,
  cartMobx as mallCartMobx,
  storeMobx,
  storeMobx as mallStoreMobx,
  tipMobx,
  shopcartCache,
  doProductMobx,
  doProductMobx as doMallProductMobx,
  payPlanMobx,
  payPlanMobx as mallPayPlanMobx,
  bankCardMobx,
  bankCardMobx as mallBankCardMobx,
  feeMobx,
  feeMobx as mallFeeMobx,
  discountMobx,
  discountMobx as mallDiscountMobx,
  shopcartMobx,
  Console
}
